<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <!-- 카드 헤더 -->
          <card-header :title="cardTitle"></card-header>

          <v-card-text>
            <!-- 투고 정보 영역 -->
            <v-row>
              <v-col cols="12">
                <div class="d-flex justify-space-between align-center">
                  <h4>{{ titles.paper }}</h4>

                  <!-- <div>
                    <custom-button
                      color="primary"
                      @click="generatePdfPreview"
                      :label="buttons.pdf"
                      rounded
                      gradient
                    ></custom-button>
                  </div> -->
                </div>
                <hr class="mt-2 mb-2" />
              </v-col>
              <v-col cols="12" lg="6">
                <div
                  class="text-container"
                  v-if="finalReview.paper?.journal?.title"
                >
                  <label class="first-section-label">
                    {{ $t("label.journal") }}
                  </label>
                  <div>
                    {{ finalReview.paper?.journal?.title }}
                  </div>
                </div>
                <div
                  class="text-container"
                  v-for="field in paperfields"
                  :key="field.idx"
                >
                  <label class="first-section-label">{{ field.label }}</label>
                  <div v-if="field.type === 'html'">
                    <div v-html="finalReview.paper[field.key]"></div>
                  </div>
                  <div
                    v-else-if="
                      field.type === 'file' && finalReview.paper[field.key]
                    "
                  >
                    <button
                      @click="handleFileClick(finalReview.paper[field.key])"
                      class="file-download"
                    >
                      {{ getFileName(finalReview.paper[field.key]) }}
                    </button>
                  </div>
                  <div v-else>
                    {{ finalReview.paper[field.key] }}
                  </div>
                </div>
              </v-col>

              <v-col cols="12" lg="6">
                <v-card
                  :height="800"
                  outlined
                  class="rounded-lg overflow-y-auto"
                  color="grey lighten-3"
                >
                  <v-card-text>
                    <div class="d-flex justify-center align-center">
                      <div ref="pdfContent">
                        <component
                          v-if="finalReview.paper && finalReview.paper.idx"
                          :is="selectedPdfTemplate"
                          :item="finalReview?.paper"
                          :journal="finalReview?.paper?.journal"
                          :startPageNumber="startPageNumber"
                        />
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- 심사 위원 영역 -->
            <v-row>
              <v-col>
                <h4>{{ titles.reviewers }}</h4>
                <hr class="mt-2 mb-2" />
                <simple-table-content
                  :columns="reviewerTableColumns"
                  :data="finalReview.reviews"
                ></simple-table-content>
              </v-col>
            </v-row>

            <!-- 게재 여부 영역 -->
            <v-row>
              <v-col>
                <h4>{{ titles.result }}</h4>
                <hr class="mt-2 mb-2" />

                <div class="radio-container">
                  <div v-for="(option, index) in options" :key="index">
                    <input
                      type="radio"
                      name="result"
                      :value="option.idx"
                      v-model="finalReview.result_type.idx"
                    />
                    {{ option.label }}
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- 총평 내용 영역 -->
            <v-row>
              <v-col>
                <h4>{{ titles.comment }}</h4>
                <hr class="mt-2 mb-2" />
                <textarea
                  class="text-box"
                  v-model="finalReview.comment"
                ></textarea>
              </v-col>
            </v-row>

            <!-- 버튼 영역 -->
            <v-row>
              <v-col>
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <custom-button
                      color="black"
                      @click="handleClose"
                      :label="buttons.close"
                      rounded
                      gradient
                    ></custom-button>
                    <custom-button
                      color="red"
                      @click="handleTempSave"
                      :label="buttons.temporarySave"
                      rounded
                      gradient
                    ></custom-button>
                  </div>
                  <div>
                    <custom-button
                      color="primary"
                      @click="handleSubmit"
                      :label="buttons.submit"
                      rounded
                      gradient
                    ></custom-button>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- 심사 상세보기 모달 -->
        <card-modal v-if="showReviewerDetailModal">
          <template v-slot:body>
            <p>{{ currentReviewer.comment }}</p>
          </template>
          <template v-slot:footer>
            <custom-button
              color="black"
              @click="controlReviewerCommentModal"
              :label="buttons.close"
              rounded
              gradient
            >
            </custom-button>
          </template>
        </card-modal>
      </v-col>

      <!-- PDF 콘텐츠 (숨겨진 상태로 렌더링) -->
      <!-- <v-col cols="12">
        <div ref="pdfContent" style="display: none">
          <component
            v-if="finalReview.paper && finalReview.paper.idx"
            :is="selectedPdfTemplate"
            :item="finalReview?.paper"
            :journal="finalReview?.paper?.journal"
            :startPageNumber="startPageNumber"
          />
        </div>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-console */
import ArticlePaperPage from "@/components/Templates/article/ArticlePaperPage.vue";
import AbstractPaperPage from "@/components/Templates/abstract/AbstractPaperPage.vue";
import ProceedingsPaperPage from "@/components/Templates/proceedings/ProceedingsPaperPage.vue";
import ArticlePreviewTemplate from "@/components/Templates/ArticlePreviewTemplate.vue";

import CardHeader from "@/components/cards/CardHeader.vue";
import SimpleTableContent from "@/components/Tables/SimpleTableContent.vue";
import CardModal from "@/components/common/Modal/CardModal.vue";
import CustomButton from "@/components/common/buttons/CustomButton.vue";

import {
  paperInfofields,
  finalResultOptions,
} from "@/views/FinalReviewView/fields";
import { getReviewerResultColumns } from "@/views/FinalReviewView/columns";
import { editFinalReviewLabel } from "@/views/FinalReviewView/label";
import {
  confirmClosePopup,
  confirmTempSavePopup,
  confirmSubmitPopup,
  success,
} from "@/views/FinalReviewView/popups";
import { generateFinalPdf } from "@/utils/pdfGenerator";

import { finalReviewApi, fileApi } from "@/api/api";

export default {
  name: "edit-final-review",
  components: {
    CardHeader,
    SimpleTableContent,
    CardModal,
    CustomButton,
    ArticlePaperPage,
    AbstractPaperPage,
    ProceedingsPaperPage,
    ArticlePreviewTemplate,
  },
  props: {
    idx: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      // labels
      cardTitle: editFinalReviewLabel.cardTitle,
      titles: editFinalReviewLabel.titles,
      buttons: editFinalReviewLabel.buttons,

      // mock data
      paperInfo: null,

      // fields & columns
      paperfields: paperInfofields,
      reviewerTableColumns: getReviewerResultColumns({
        description: this.showReviewDetail,
      }),
      options: finalResultOptions,

      // boolean
      showReviewerDetailModal: false,

      // init data
      currentReviewer: null,
      finalReview: {
        idx: this.idx,
        result: null,
        comment: null,
        level: null,
        paper: {
          idx: null,
          abstract: null,
          keyword: null,
          review_type: null,
          title: null,
          title_eng: null,
        },
        result_type: {
          idx: null,
          name: null,
        },
      },
    };
  },
  methods: {
    /**
     * 뒤로가기
     */
    goBack() {
      this.$router.push({ name: "final-review-status" });
    },
    controlReviewerCommentModal() {
      this.showReviewerDetailModal = !this.showReviewerDetailModal;
    },
    showReviewDetail(reviewer) {
      if (reviewer.status === "COMPLETED") {
        this.currentReviewer = reviewer;
        this.controlReviewerCommentModal();
      } else {
        this.notifyVue({
          alertMessage: "심사가 끝나지 않았습니다.",
          color: "warning",
        });
      }
    },
    /**
     * 총평 상세 데이터 api 요청
     */
    fetchFinalReviewDetail(finalReviewIdx) {
      finalReviewApi
        .showFinalReview({ idx: finalReviewIdx })
        .then((response) => {
          if (response && response.status == 200) {
            this.finalReview = response.data.response;
          } else {
            this.notifyVue({
              alertMessage: editFinalReviewLabel.apiRequestFailMessage,
              color: "danger",
            });
          }
        });
    },
    getFileName(filePath) {
      return filePath.split("/").pop();
    },
    async handleFileClick(filePath) {
      try {
        const fileName = filePath.split("/").pop();
        const params = {
          file_name: filePath,
        };

        const response = await fileApi.fileDownload(params);

        if (response && response.status === 200) {
          const mimeType = response.headers["content-type"];
          const blob = new Blob([response.data], { type: mimeType });
          const fileURL = URL.createObjectURL(blob);

          // 자동 열기
          // if (mimeType === "application/pdf" || mimeType.startsWith("image/")) {
          //   const link = document.createElement("a");
          //   link.href = fileURL;
          //   link.setAttribute("download", fileName); // 다운로드 파일 이름 설정
          //   link.setAttribute("target", "_blank"); // 새 창에서 열기
          //   document.body.appendChild(link);
          //   link.click();
          //   link.parentNode.removeChild(link);
          // } else {
          //   // 다운로드로 처리
          const link = document.createElement("a");
          link.href = fileURL;
          link.setAttribute("download", fileName); // 다운로드 파일 이름 설정
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          // }
        }
      } catch (error) {
        this.notifyVue({
          alertMessage:
            "파일 다운로드에 실패했습니다. 잠시후 다시 시도해주세요.",
          color: "danger",
        });
      }
    },
    async updateFinalReviewContent(status) {
      const data = {
        idx: this.finalReview.idx,
        result_type_idx: this.finalReview.result_type.idx,
        comment: this.finalReview.comment,
        level: this.finalReview.level,
        status: status,
        paper_status: this.finalReview.paper.status,
        paper_category: this.finalReview.paper.category,
      };

      finalReviewApi.updateFinalReview(data).then((response) => {
        if (response && response.status == 200) {
          this.fetchFinalReviewDetail(this.finalReview.idx);
          success();
        } else {
          this.notifyVue({
            alertMessage: editFinalReviewLabel.apiRequestFailMessage,
            color: "danger",
          });
        }
      });
    },
    async handleClose() {
      const close = await confirmClosePopup();
      if (close) {
        this.goBack();
      }
    },
    async handleTempSave() {
      const isConfirm = await confirmTempSavePopup();
      if (isConfirm) {
        await this.updateFinalReviewContent("IN_PROGRESS");
      }
    },
    async handleSubmit() {
      if (!this.finalReview.result_type || !this.finalReview.result_type.idx) {
        this.notifyVue({
          alertMessage: "게재 여부를 선택하세요.",
          color: "warning",
        });
        return false;
      }

      if (
        this.finalReview.reviews.some((review) => review.status !== "COMPLETED")
      ) {
        this.notifyVue({
          alertMessage: "모든 심사 위원의 심사가 완료되지 않았습니다.",
          color: "danger",
        });
        return false;
      }

      const isConfirm = await confirmSubmitPopup();
      if (isConfirm) {
        const paperStatus = this.checkFinalResult();
        this.finalReview.paper.status = paperStatus.status;
        this.finalReview.paper.category = paperStatus.category;

        await this.updateFinalReviewContent("COMPLETED");

        this.goBack();
      }
    },
    checkFinalResult() {
      if (this.finalReview.result_type.idx == 1) {
        return {
          category: "PUBLICATION",
          status: "WAITING",
        };
      } else if (this.finalReview.result_type.idx == 2) {
        return {
          category: "FINAL_REVISION",
          status: "WAITING",
        };
      } else if (this.finalReview.result_type.idx == 3) {
        return {
          category: "REVISION",
          status: "WAITING",
        };
      } else {
        return {
          category: "REJECTED",
          status: "COMPLETED",
        };
      }
    },
    generatePdfPreview() {
      const element = this.$refs.pdfContent;

      if (!element) {
        // eslint-disable-next-line no-console
        console.error("PDF 콘텐츠 요소를 찾을 수 없습니다.");
        return;
      }

      generateFinalPdf({ element: element });
    },
    notifyVue({
      verticalAlign = "top",
      horizontalAlign = "center",
      alertMessage,
      color = "danger",
    }) {
      this.$notify({
        timeout: 3000,
        message: alertMessage,
        icon: "priority_high",
        type: color,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
      });
    },
  },
  computed: {
    selectedPdfTemplate() {
      if (this.finalReview.paper.journal?.journal_type?.code === "abst") {
        return "abstract-paper-page";
      } else if (
        this.finalReview.paper.journal?.journal_type?.code === "procs"
      ) {
        return "proceedings-paper-page";
      }
      // return "article-paper-page";
      return "article-preview-template";
    },
    startPageNumber() {
      if (this.finalReview.paper?.journal?.journal_type?.code === "jnl") {
        return 2;
      }
      return 1;
    },
  },
  mounted() {
    this.fetchFinalReviewDetail(this.idx);
  },
};
</script>

<style lang="scss" scoped>
$font-color: #424242;

.section {
  margin-bottom: 50px;
}

h4 {
  font-weight: bold;
  color: $font-color;
  margin-bottom: -2px;
}

hr {
  border: 1px solid rgba(233, 233, 233, 0.5);
}

.download-button {
  width: 70px;
  height: 30px;
  margin-top: 15px;
}

.first-section-header {
  display: flex;
  justify-content: space-between;
}

.first-section-label {
  font-weight: 600;
  color: $font-color;
  min-width: 120px;
}

.text-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.text-box {
  font-family: "KoPubWorldDotum", "Roboto", "Helvetica", "Arial";
  border: 1px solid #ddd;
  color: #565656;
  width: 100%;
  height: 250px;
  resize: none;
  overflow: auto;
  margin-top: 10px;
}

.score {
  display: flex;
  justify-self: flex-end;
  font-weight: bold;
  font-size: medium;
  padding-right: 50px;
}

.radio-container {
  display: flex;
  justify-content: space-between;
}

.bottom-button-container {
  display: flex;
  justify-content: space-between;
}

.file-download {
  background: none;
  border: none;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
  margin: 0;
  outline: none;
}

.file-download:hover {
  color: #0056b3;
  text-decoration: none;
}

.file-download:focus {
  outline: none;
}
</style>
